import React from "react"

const ThemeContext = React.createContext({
  isDark: false,
  setIsDark: (isDark: boolean) => {},
})

export default ThemeContext
